import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 mb-4" }
const _hoisted_3 = {
  class: "card",
  style: {"border-radius":"10px"}
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = {
  class: "mb-0",
  style: {"font-weight":"bold"}
}
const _hoisted_7 = { class: "d-flex align-items-center ms-auto" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "period-label mb-2",
  style: {"font-size":"12px"}
}
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "chart-container" }
const _hoisted_13 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center h-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_chart = _resolveComponent("chart")!
  const _component_GridLoading = _resolveComponent("GridLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t("styleAnalysesChart.title")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTimePeriod(-1))),
                class: "btn btn-sm btn-outline-secondary me-2",
                disabled: _ctx.loading
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
              ], 8, _hoisted_8),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTimePeriod(1))),
                class: "btn btn-sm btn-outline-secondary",
                disabled: _ctx.loading || _ctx.isCurrentPeriod
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
              ], 8, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentPeriodLabel), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_chart, {
                  key: _ctx.chartKey,
                  series: _ctx.series,
                  "category-axis": _ctx.categoryAxis,
                  "value-axis": _ctx.valueAxis,
                  tooltip: _ctx.tooltipOptions,
                  legend: _ctx.legendOptions,
                  theme: 'sass',
                  "chart-area": { height: 300 }
                }, null, 8, ["series", "category-axis", "value-axis", "tooltip", "legend"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_GridLoading)
                ]))
          ])
        ])
      ])
    ])
  ]))
}